import { render, staticRenderFns } from "./access-warning.vue?vue&type=template&id=4ca3786e&"
import script from "./access-warning.vue?vue&type=script&lang=js&"
export * from "./access-warning.vue?vue&type=script&lang=js&"
import style0 from "./access-warning.vue?vue&type=style&index=0&id=4ca3786e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports